import { ref } from 'vue'

// Estado compartilhado do modal de documentos legais — os links que o abrem
// estão espalhados (rodapé, banner de cookies e aceite do cadastro), então
// o modal fica montado uma única vez no App.vue e é acionado daqui, mesmo
// padrão de useSignupModal.js.
const isOpen = ref(false)
const legalDocument = ref(null) // 'terms' | 'privacy'

export function useLegalModal() {
  const openLegalModal = (doc) => {
    legalDocument.value = doc
    isOpen.value = true
  }
  const closeLegalModal = () => { isOpen.value = false }

  return { isOpen, legalDocument, openLegalModal, closeLegalModal }
}
